import React, { useEffect, useState } from 'react'

import {
  IconButton,
  Typography,
  TextField,
  Autocomplete,
  Collapse
} from '@mui/material'
import NorthIcon from '@mui/icons-material/North'
import SouthIcon from '@mui/icons-material/South'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff'
import classNames from 'classnames'

import styles from './CategoriesHeader.module.css'

function CategoriesHeader({
  setOrderByParam,
  setFilterByParam,
  categoriesOptions
}) {
  const [orderBy, setOrderBy] = useState({
    criteria: 'subcategory',
    order: false
  })
  const [filterBy, setFilterBy] = useState({
    criteria: 'category',
    selected: null
  })
  const [showFilters, setShowFilters] = useState(false)

  const handleClickSubCategoryFilter = () => {
    handleSortChange('subcategory')
  }

  const handleClickCategoryFilter = () => {
    handleSortChange('category')
  }

  const handleSortChange = (criteria) => {
    setOrderBy((prevState) => ({
      criteria,
      order: criteria === prevState.criteria ? !prevState.order : false
    }))
  }

  const handleFilterChange = (event, filterValue) => {
    setFilterBy(() => ({
      criteria: 'category',
      selected: filterValue
    }))
  }

  const toggleShowFilters = () => {
    setShowFilters(!showFilters)
  }

  useEffect(() => {
    setOrderByParam(orderBy)
    setFilterByParam(filterBy)
  }, [orderBy, filterBy])

  return (
    <div className={styles.productsHeaderContainer}>
      <div className={styles.productsHeader}>
        <IconButton
          onClick={() => handleClickSubCategoryFilter()}
          className={classNames(styles.subCategoryButton, [
            orderBy.criteria === 'subcategory' && styles.lastPressed
          ])}
        >
          {orderBy.criteria === 'subcategory' &&
            (orderBy.order ? (
              <NorthIcon fontSize="small" className={styles.icon} />
            ) : (
              <SouthIcon fontSize="small" className={styles.icon} />
            ))}
          <Typography className={styles.text}>Subcategory</Typography>
        </IconButton>
        <IconButton
          onClick={() => handleClickCategoryFilter()}
          className={classNames(styles.categoryButton, [
            orderBy.criteria === 'category' && styles.lastPressed
          ])}
        >
          {orderBy.criteria === 'category' &&
            (orderBy.order ? (
              <NorthIcon fontSize="small" className={styles.icon} />
            ) : (
              <SouthIcon fontSize="small" className={styles.icon} />
            ))}
          <Typography className={styles.text}>Category</Typography>
        </IconButton>
        <IconButton
          onClick={() => toggleShowFilters()}
          className={styles.filterButton}
        >
          {showFilters ? (
            <FilterAltOffIcon fontSize="small" className={styles.icon} />
          ) : (
            <FilterAltIcon fontSize="small" className={styles.icon} />
          )}
        </IconButton>
      </div>
      <Collapse in={showFilters}>
        <div className={styles.filtersContainer}>
          <Autocomplete
            className={styles.autocomplete}
            options={categoriesOptions}
            onChange={handleFilterChange}
            renderInput={(params) => (
              <TextField {...params} label="Filter by category" />
            )}
          />
        </div>
      </Collapse>
    </div>
  )
}

export default CategoriesHeader
